"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _HelpOutlined = _interopRequireDefault(require("@mui/icons-material/HelpOutlined"));

var _style = _interopRequireDefault(require("./style"));

var _react2 = require("@emotion/react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FormLinksPropiedad(props) {
  const {
    facebook,
    instagram,
    tripadvisor,
    pagina_web,
    acceso_rapido,
    openTooltip,
    handleTooltipOpen,
    handleTooltipClose,
    isMobile
  } = props;
  const theme = (0, _styles.useTheme)();
  const classes = (0, _style.default)(theme);
  return (0, _react2.jsx)(_react.default.Fragment, null, (0, _react2.jsx)(_material.FormControl, {
    fullWidth: true,
    "aria-describedby": "facebook-text"
  }, (0, _react2.jsx)(_material.InputLabel, {
    htmlFor: "facebook"
  }, "Facebook"), (0, _react2.jsx)(_material.Input, {
    onBlur: props.onBlurInput,
    defaultValue: facebook,
    placeholder: "https://www.facebook.com/xxxx",
    inputProps: {
      'data-estado': 'facebook'
    }
  })), (0, _react2.jsx)(_material.FormControl, {
    fullWidth: true,
    css: classes.input,
    "aria-describedby": "instagram-text"
  }, (0, _react2.jsx)(_material.InputLabel, {
    htmlFor: "instagram"
  }, "Instagram"), (0, _react2.jsx)(_material.Input, {
    onBlur: props.onBlurInput,
    defaultValue: instagram,
    placeholder: "https://www.instagram.com/xxxx",
    inputProps: {
      'data-estado': 'instagram'
    }
  })), (0, _react2.jsx)(_material.FormControl, {
    fullWidth: true,
    css: classes.input,
    "aria-describedby": "tripadvisor-text"
  }, (0, _react2.jsx)(_material.InputLabel, {
    htmlFor: "tripadvisor"
  }, "Tripadvisor"), (0, _react2.jsx)(_material.Input, {
    defaultValue: tripadvisor,
    onBlur: props.onBlurInput,
    placeholder: "https://www.tripadvisor.com/xxxx",
    inputProps: {
      'data-estado': 'tripadvisor'
    }
  })), (0, _react2.jsx)(_material.FormControl, {
    fullWidth: true,
    css: classes.input,
    "aria-describedby": "web-text"
  }, (0, _react2.jsx)(_material.InputLabel, {
    htmlFor: "web"
  }, "Pagina web propia"), (0, _react2.jsx)(_material.Input, {
    defaultValue: pagina_web,
    onBlur: props.onBlurInput,
    inputProps: {
      'data-estado': 'pagina_web'
    }
  })), (0, _react2.jsx)(_material.Grid, {
    container: true
  }, (0, _react2.jsx)(_material.Grid, {
    item: true,
    xs: 4,
    sm: 6
  }, (0, _react2.jsx)(_material.FormControl, {
    fullWidth: true,
    css: classes.input,
    "aria-describedby": "link-propio-text"
  }, (0, _react2.jsx)(_material.InputLabel, {
    htmlFor: "link-propio"
  }, "Link Propio"), (0, _react2.jsx)(_material.Input, {
    defaultValue: acceso_rapido,
    onBlur: props.onBlurInput,
    inputProps: {
      'data-estado': 'acceso_rapido'
    }
  }))), (0, _react2.jsx)(_material.Grid, {
    item: true,
    css: classes.linkAlqa,
    xs: 6,
    sm: 3
  }, (0, _react2.jsx)(_material.Typography, {
    css: classes.linkAlqaSpan
  }, ".alquilerargentina.com")), (0, _react2.jsx)(_material.Grid, {
    item: true,
    css: classes.tooltip,
    xs: 2,
    sm: 3
  }, isMobile ? (0, _react2.jsx)(_material.Tooltip, {
    onClose: handleTooltipClose,
    onClick: handleTooltipOpen,
    open: openTooltip,
    disableHoverListener: true,
    disableTouchListener: true,
    title: "aqu\xED pod\xE9s generar tu propio link para poder ingresar directamente a tu anuncio"
  }, (0, _react2.jsx)(_material.IconButton, {
    "aria-label": "delete"
  }, (0, _react2.jsx)(_HelpOutlined.default, null))) : (0, _react2.jsx)(_material.Tooltip, {
    title: "aqu\xED pod\xE9s generar tu propio link para poder ingresar directamente a tu anuncio"
  }, (0, _react2.jsx)(_material.IconButton, {
    "aria-label": "delete"
  }, (0, _react2.jsx)(_HelpOutlined.default, null))))));
}

var _default = FormLinksPropiedad;
exports.default = _default;